import { defineStore } from 'pinia'

export const Tools = defineStore('sch_tools', {
    state: () => {
        return { sch_tools: null }
    },
    actions: {
        get() {
            return this.sch_tools
        },
        set(data) {
            this.sch_tools = data
        }
    },
})

export const Current = defineStore('sch_current', {
    state: () => {
        return { sch_current: {
                group_guid: null,
                direction_guid: null
            }
        }
    },
    actions: {
        get() {
            return this.sch_current
        },
        set(data) {
            this.sch_current = data
        }
    },
})

export const Deletion = defineStore('sch_deletion', {
    state: () => {
        return { sch_deletion: false }
    },
    actions: {
        get() {
            return this.sch_deletion
        },
        set(data) {
            this.sch_deletion = data
        }
    },
})